import React from 'react'
import PriorityBadge from './PriorityBadge'
import styles from './ProtocolInfographic.module.css'

export default function RecCard({ rec, accent }) {
  if (!rec) {
    return null
  }

  return (
    <div className={styles.recCardWrapper}>
      <div className={styles.recCardHeader}>
        <h4 className={styles.recTitle}>{rec.title}</h4>
        {rec.priority && <PriorityBadge priority={rec.priority} />}
      </div>

      <div className={styles.recMeta}>
        <span role="img" aria-label="clock" className={styles.metaIcon}>🕐</span>
        {rec.timeframe && <span className={styles.metaText}>{rec.timeframe}</span>}
        {rec.timeframe && <span className={styles.metaDot}>·</span>}
        <span role="img" aria-label="flame" className={styles.flameIcon} style={{ color: accent }}>🔥</span>
        <span className={styles.metaImpact} style={{ color: accent }}>
          Impact {rec.impact_score || 0}
        </span>
      </div>

      {rec.why_condensed && <p className={styles.recWhy}>{rec.why_condensed}</p>}

      {rec.best_action && (
        <div className={styles.actionBox} style={{ backgroundColor: `color-mix(in oklab, ${accent} 8%, transparent)` }}>
          <div className={styles.actionLabel} style={{ color: accent }}>Best Action</div>
          <p className={styles.actionText}>{rec.best_action}</p>
        </div>
      )}

      {rec.progress_metric && (
        <div className={styles.metricRow}>
          <span className={styles.trendingUpIcon} style={{ color: accent }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
              <polyline points="17 6 23 6 23 12" />
            </svg>
          </span>
          <span className={styles.metricText}>
            <span className={styles.metricLabel}>Metric:</span> {rec.progress_metric}
          </span>
        </div>
      )}

      <div className={styles.impactBarBox}>
        <div
          className={styles.impactFill}
          style={{
            width: `${rec.impact_score || 0}%`,
            background: `linear-gradient(90deg, ${accent}, color-mix(in oklab, ${accent} 60%, white))`
          }}
        />
      </div>
    </div>
  )
}
